import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { reviewsSelector } from '../../../../../store/slices/reviews';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';


const InappropriateInstructions = () => {
  const { similarReviews } = useSelector(reviewsSelector);

  const tableData = useMemo(() => {
    const rawInstructions = similarReviews?.agents?.inappropriateInstructions;
    
    if (typeof rawInstructions === 'string') {
        const parsed = JSON.parse(rawInstructions);
        return parsed?.InappropriateInstructions?.InappropriateInstructions || [];
      } 
    return [];
  }, [similarReviews?.agents?.inappropriateInstructions]);

  const columns = useMemo(() => [
    {
      header: 'Instruction',
      accessorKey: 'Instruction',
    },
    {
      header: 'Reason',
      accessorKey: 'Reason',
    },
  ], []);

  const table = useMaterialReactTable({
    columns,
    data: tableData,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableSorting: false,
    enableHiding: false,
    enableColumnActions: false,
    muiTableContainerProps: {
      sx: {
        maxHeight: 'unset'
      }
    },
    muiTablePaperProps: {
      className: 'std_table review-requests',
      sx: { boxShadow: 'none' }
    },
    muiTableBodyCellProps: {
      sx: { border: 'none' }
    }
  });

  return <MaterialReactTable table={table} />;
};

export default InappropriateInstructions;
